import { service } from "@ember/service";
import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class FileStorageVolumesCreateController extends Controller {
  @service router;
  @service store;

  get project() {
    return this.model.project;
  }

  get dataCenters() {
    return this.model.dataCenters;
  }

  get plans() {
    return this.model.plans.plans;
  }

  get supportedDataCenters() {
    return this.dataCenters
      .filter((dataCenter) => dataCenter.hasFileStorageVolumeSupport)
      .map((dataCenter) => ({ value: dataCenter.name }));
  }

  @tracked hasAutoPromotion = true;
  @tracked name = "";
  @tracked selectedDataCenter = "";
  @tracked selectedPlan = null;

  get canNotSubmit() {
    return (
      this.project.hasReadAccess ||
      this.project.organization.isRestricted ||
      !this.name ||
      !this.selectedDataCenter ||
      !this.selectedPlan
    );
  }

  createFileStorageVolumeTask = task(async () => {
    let { hasAutoPromotion, project, name, selectedDataCenter, selectedPlan } = this;

    let volume = this.store.createRecord("file-storage-volume", {
      project,
      dataCenter: selectedDataCenter,
      hasAutoPromotion,
      name,
      plan: selectedPlan,
    });

    await this.store.request(saveRecord(volume)).catch((error) => {
      volume.unloadRecord();
      throw error;
    });

    this.router.transitionTo("file-storage-volumes.details", volume.id);
  });

  @action
  onFormChange({ name, hasAutoPromotion, dataCenter }) {
    this.name = name;
    this.hasAutoPromotion = Boolean(hasAutoPromotion);
    this.selectedDataCenter = dataCenter;
  }

  @action
  selectPlan(plan) {
    this.selectedPlan = plan;
  }
}
